<!-- components/AnnualDocsDialog.vue -->
<template>
  <v-dialog v-model="dialogVisible" max-width="900px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        small
        color="primary"
        v-bind="attrs"
        v-on="on"
        class="ml-2"
      >
        <v-icon left>mdi-file-document-outline</v-icon>
        View Annual Docs
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline primary white--text">
        Annual Document Details
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-container v-if="annualDocs">
          <v-row>
            <v-col cols="6">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Document Type</v-list-item-subtitle>
                  <v-list-item-title>{{ annualDocs.Type }} - {{ annualDocs.Mandatory }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            
            <v-col cols="6">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Status</v-list-item-subtitle>
                  <v-list-item-title>
                    <v-chip
                      :color="annualDocs.Status === 'Current' ? 'success' : 'warning'"
                      small
                    >
                      {{ annualDocs.Status }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>

            <v-col cols="12">
              <h3>Focus</h3>
              <p>{{ annualDocs.Focus }}</p>
            </v-col>

            <v-col cols="12">
              <h3>Details</h3>
              <p>{{ annualDocs.Details }}</p>
            </v-col>

            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>

            <v-col cols="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Date Issued</v-list-item-subtitle>
                  <v-list-item-title>{{ formatDate(annualDocs.DateIssued) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Date Requested</v-list-item-subtitle>
                  <v-list-item-title>{{ formatDate(annualDocs.DateRequested) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Date Expires</v-list-item-subtitle>
                  <v-list-item-title>
                    <span :class="isExpired(annualDocs.DateExpires) ? 'red--text' : ''">
                      {{ formatDate(annualDocs.DateExpires) }}
                    </span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>

            <v-col cols="12" v-if="annualDocs.Notes">
              <h3>Notes</h3>
              <p>{{ annualDocs.Notes }}</p>
            </v-col>
          </v-row>
        </v-container>
        
        <div v-else class="text-center pa-4">
          No annual documents available
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AnnualDocsDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    annualDocs: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).format('MM/DD/YYYY');
    },
    isExpired(dateString) {
      if (!dateString) return false;
      return moment(dateString).isBefore(moment());
    },
    closeDialog() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.headline {
  font-size: 1.25rem !important;
}
</style>